import React, { useEffect, useRef } from "react";

interface VideoWithAspectRatioProps {
  aspectRatio: number;
  src: string;
  index: number;
  setPlayingVideo: (index: number | null) => void;
  playingVideo: number | null;
  onVideoTap?:()=>void
}

const VideoWithAspectRatio: React.FC<VideoWithAspectRatioProps> = ({
  aspectRatio,
  src,
  index,
  setPlayingVideo,
  playingVideo,
  onVideoTap
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);
  // const height = 555 / aspectRatio;
 const handleVideoClick = (e:any) => {
    // This ensures video controls still work
    if (typeof onVideoTap === 'function') {
      onVideoTap(); // Manually trigger parent's action
    }
  };
  useEffect(() => {
    // Cleanup existing observer
    if (observerRef.current && videoRef.current) {
      observerRef.current.unobserve(videoRef.current);
    }

    // Create a new observer to monitor visibility
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.75) {
            setPlayingVideo(index); // Notify parent that this video is in view
          }
        });
      },
      {
        threshold: [0.75], // Play only when 75% of the video is visible
        rootMargin: "0px",
      }
    );

    if (videoRef.current) {
      observerRef.current.observe(videoRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [index, setPlayingVideo]);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (!videoElement) return;

    if (playingVideo === index) {
      // Play the current video
      videoElement.play().catch((err) => {
        console.error("Error playing video:", err);
      });
    } else {
      // Pause other videos
      videoElement.pause();
      videoElement.currentTime = 0; // Reset to the beginning
    }
  }, [playingVideo, index]);

  const numRatio = Number(aspectRatio);
  const ratio =
    numRatio > 0 && numRatio < 10
      ? numRatio
      : numRatio > 10
      ? Math.round((555 / numRatio) * 100) / 100
      : 1.78;

  return (
    <>
    <div
      className="video-container"
      style={{
        width: "100%",
        aspectRatio: `${ratio}`,
        maxHeight: "630px",
        backgroundColor: "#000000",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <video
        ref={videoRef}
        src={src}
        controls
        muted
        autoPlay
        preload="auto"
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
        onTouchStart={handleVideoClick}
      />
    </div>
    </>
  );
};

export default React.memo(VideoWithAspectRatio);
